export default __webpack_public_path__ + "static/assets/a1d933d8457e366116b71014c82a951a.svg";